<script setup>
import { computed } from 'vue';
import { onKeyStroke } from '@vueuse/core';

import TeleportWithDirection from 'dashboard/components-next/TeleportWithDirection.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  title: { type: String, required: true },
  description: { type: String, default: '' },
  width: {
    type: String,
    default: '2xl',
    validator: value => ['xl', '2xl', '3xl', '4xl'].includes(value),
  },
});

const emit = defineEmits(['close']);

const maxWidthClass = computed(
  () =>
    ({
      xl: 'max-w-xl',
      '2xl': 'max-w-2xl',
      '3xl': 'max-w-3xl',
      '4xl': 'max-w-4xl',
    })[props.width]
);

onKeyStroke('Escape', () => emit('close'));
</script>

<template>
  <TeleportWithDirection to="body">
    <div
      class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm"
      @click.self="emit('close')"
    >
      <div
        class="flex flex-col w-full max-h-[90vh] rounded-xl border border-n-weak bg-n-alpha-3 backdrop-blur-[100px] shadow-xl"
        :class="maxWidthClass"
      >
        <div
          class="flex items-start justify-between flex-shrink-0 gap-4 p-6 pb-4"
        >
          <div class="flex flex-col gap-1 min-w-0">
            <h3 class="text-base font-medium leading-6 text-n-slate-12">
              {{ title }}
            </h3>
            <p v-if="description" class="mb-0 text-sm text-n-slate-11">
              {{ description }}
            </p>
          </div>
          <Button
            variant="ghost"
            color="slate"
            size="sm"
            icon="i-lucide-x"
            @click="emit('close')"
          />
        </div>
        <div class="flex-1 min-h-0 px-6 pb-6 overflow-y-auto">
          <slot />
        </div>
      </div>
    </div>
  </TeleportWithDirection>
</template>
